import { Fragment, useRef, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/react/24/outline'

interface IModal {
  open: boolean
  setOpen: any
  title: string
  onConfirm: any
  defaultValue: IVersion
}
export interface IVersion {
  android: number
  ios: number
}
export default function EnterVersion({ defaultValue, open, setOpen, title, onConfirm }: IModal) {
  const cancelButtonRef = useRef(null)
  const [version, setVersion] = useState(defaultValue)
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as='div' className='relative z-10' initialFocus={cancelButtonRef} onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity' />
        </Transition.Child>

        <div className='fixed inset-0 z-10 overflow-y-auto'>
          <div className='flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
              enterTo='opacity-100 translate-y-0 sm:scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 translate-y-0 sm:scale-100'
              leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
            >
              <Dialog.Panel className='relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg'>
                <div className='bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4'>
                  <div className='w-full sm:flex sm:items-start'>
                    <div className='mt-3 w-full text-center sm:mt-0 sm:ml-2 sm:mr-2 sm:text-left'>
                      <Dialog.Title as='h3' className='text-lg font-medium leading-6 text-gray-900'>
                        {title}
                      </Dialog.Title>
                      <div className='mt-4 space-y-3 '>
                        <div>
                          <label
                            className={`block text-sm font-medium text-gray-700 ${'text-gray-700'}`}
                          >
                            Android
                          </label>
                          <input
                            type='number'
                            name='android'
                            defaultValue={defaultValue.android}
                            onChange={(e) => {
                              setVersion({ ...version, [e.target.name]: parseInt(e.target.value) })
                              console.log(version)
                            }}
                            className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm ${'border focus:border-indigo-500 focus:ring-indigo-500'}`}
                          />
                        </div>
                        <div>
                          <label
                            className={`block text-sm font-medium text-gray-700 ${'text-gray-700'}`}
                          >
                            IOS
                          </label>
                          <input
                            type='number'
                            defaultValue={defaultValue.ios}
                            name='ios'
                            onChange={(e) =>
                              setVersion({ ...version, [e.target.name]: parseInt(e.target.value) })
                            }
                            className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm ${'border focus:border-indigo-500 focus:ring-indigo-500'}`}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6'>
                  <button
                    type='button'
                    className='inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm'
                    onClick={() => {
                      onConfirm(version)
                      setOpen(false)
                    }}
                  >
                    Submit
                  </button>
                  <button
                    type='button'
                    className='mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50   focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm'
                    onClick={() => {
                      setOpen(false)
                    }}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
